import { datadogRum } from '@datadog/browser-rum';
import { config } from '@base/constants';

const { appVersion: version, environment } = config;
const isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  datadogRum.init({
    applicationId: '6655f46c-71ee-4f4f-a075-62a958b2b9a0',
    clientToken: 'pub993ec28ebe63cee0236d0085c6606f8a',
    service: 'tavola-frontend',
    defaultPrivacyLevel: 'mask-user-input',
    sessionReplaySampleRate: 100,
    sessionSampleRate: 100,
    environment,
    version,
  });
}
